import { FC } from 'react';
import { List, ListItem, ListItemIcon, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface PlanListProps {
  title: string;
  items: string[];
}

const PlanList: FC<PlanListProps> = ({ title, items }) => {
  return (
    <>
      <Typography variant="caption">{title}</Typography>
      <List dense sx={{ marginBottom: '4px' }}>
        {items.map((item) => {
          return (
            <ListItem disableGutters disablePadding key={item}>
              <ListItemIcon sx={{ minWidth: 'fit-content', mr: '8px' }}>
                <CheckIcon sx={{ width: '14px', height: '14px' }} />
              </ListItemIcon>
              <Typography variant="caption">{item}</Typography>
            </ListItem>
          );
        })}
      </List>
    </>
  );
};

export default PlanList;
